<div class="chart-loading-wrap">
  <span class="chart-spinner"></span>
</div>
